enum SignedStatus {
  sentForSigning = 'Sent for signing',
  signedManually = 'Signed manually',
  signedWithDocuSign = 'Signed with DocuSign',
  signedWithSignFlow = 'Signed with SignFlow',
  allSigned = 'All signed',
}

export default SignedStatus;
export type VerifySignedStatus = Utils.VerifyExtends<Model.Enum.SignedStatus, Utils.ValueOf<typeof SignedStatus>>;
